import * as classnames from 'classnames'
import * as React from 'react'

import { IItemCard } from '../interface'

import LockupAudioPreview from '../lockupAudioPreview'
import LockupAudioTrackInfo from '../lockupAudioTrackInfo'
import LockupActionPanel from '../lockupListActionPanel'
import LockupTitleAuthor from '../lockupTitleAuthor'

import * as styles from './itemCardAudioContent.module.css'

const ItemCardAudioContent = (props: IItemCard) => {
  const { viewType, isCardFocused, isCardHovered } = props
  const isGrid = viewType === 'grid'
  const downloadHighlight = isCardFocused || isCardHovered

  return (
    <div className={styles.root}>
      <div
        className={classnames(styles.trackInfo, {
          [styles.trackInfoGrid]: isGrid
        })}
      >
        <LockupAudioPreview {...props} />

        <LockupAudioTrackInfo {...props} />
      </div>
      <div
        className={classnames(styles.itemInfo, {
          [styles.itemInfoGrid]: isGrid
        })}
      >
        <span
          className={classnames(styles.title, {
            [styles.titleGrid]: isGrid
          })}
        >
          <LockupTitleAuthor inline={!isGrid} {...props} />
        </span>
        <span
          className={classnames(styles.icons, { [styles.gridIcons]: isGrid })}
        >
          <LockupActionPanel
            {...props}
            includeDownload={true}
            downloadHighlight={downloadHighlight}
          />
        </span>
      </div>
    </div>
  )
}

export default ItemCardAudioContent
